// extracted by mini-css-extract-plugin
module.exports = {"root":"TablePaginationActions_root__3_qDj"};